<template>
  <div :class="containerWidth" class="login-container">
    <GauravImpexLogo class="justify-center" :variant="appLogoVariant" />
    <div class="description primary--text text-center mb-6">
      Login to Continue
    </div>
    <ValidationObserver v-slot="{ passes }">
      <div class="mb-4" v-on:keyup.enter="passes(login)">
        <TextField
          v-model="email"
          showIcons
          rules="required|email"
          :loading="isLoginFormLoading"
          label="Email"
          placeholder="john.doe@gmail.com"
        />
        <TextField
          v-model="password"
          showIcons
          rules="required"
          :loading="isLoginFormLoading"
          label="Password"
          class="mb-3"
          type="password"
          placeholder="••••••••"
        />
      </div>
      <div class="form-content">
        <div class="remember">
          <v-checkbox v-model="toggleRemember" label="Remember Me"></v-checkbox>
        </div>
        <v-btn text class="forgot-password" @click="$router.push({ name: 'auth.forgot-password' })"
          >Forgot Password?</v-btn
        >
      </div>
      <v-btn
        color="button-primary"
        large
        class="white--text"
        block
        :loading="isLoginFormLoading"
        @click="passes(login)"
      >
        <span class="font-weight-bold fs-15">Log In</span>
      </v-btn>
    </ValidationObserver>
    <div class="text-center mt-3">
      <v-btn color="primary" text @click="$router.push({ name: 'auth.signup' })">Create an account</v-btn>
    </div>
  </div>
</template>
<script>
import GauravImpexLogo from "@/components/GauravImpexLogo";
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import * as AT from "@/modules/AuthModule/store/actionTypes";
import { SNACKBAR } from "@/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "Login",
  components: {
    GauravImpexLogo,
    ValidationObserver,
    TextField
  },
  mixins: [commonMethodsMixin],
  data() {
    return {
      email: "",
      password: "",
      isLoginFormLoading: false,
      toggleRemember: true
    };
  },
  methods: {
    login() {
      this.isLoginFormLoading = true;
      const formData = {
        email: this.email,
        password: this.password
      };
      this.$store
        .dispatch(AT.LOGIN, formData)
        .then(() => this.$router.push({ name: "dashboard.home" }))
        .catch(err => {
          var errorMessage = "";
          if (err.data.message === "Token cannot be built") {
            errorMessage = "Wrong email or password";
          }
          if (err.data.errors) {
            errorMessage = [].concat.apply([], Object.values(err.data.errors));
          }
          this.$store.dispatch(SNACKBAR, {
            color: "error",
            text: `${errorMessage}`
          });
        })
        .finally(() => (this.isLoginFormLoading = false));
    }
  }
};
</script>
<style lang="scss">
.login-container {
  margin: auto;

  .description {
    font-size: 1.3rem;
    font-weight: 600;
  }

  .form-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
